module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/clip_link-702ffee47a6be6d76e6cdae6c0875b8f.svg";